import React, {
  useEffect, useState, useReducer,
} from 'react';
import {
  Select, SelectOption, Tooltip, TooltipButton, IconInfo,
}
  from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { validateDlsInput } from '../../Validations/Validations';
import { parseHtml } from '../../utils/util';
import { performOperations } from '../../Operations/Operations';
import useDropDownOptions from '../../CustomHooks/useDropDownOptions';

const getVal = require('lodash/get');
/**
 * returns DLS select component
 * @param {*} props
 */
/* eslint complexity: ["error", 30] -- need to increase complexity */
/* eslint-disable max-len -- need */
const DlsSelect = (props) => {
  const {
    fetchUrl,
    fieldLabel,
    fieldId,
    fieldValidation,
    cssProperties,
    selectKey,
    selectShowKey,
    memberInfo,
    onElementChange = [],
    handleOnChangeEvents,
    showProductInfo,
    fieldDefaultOptionLabel = 'Choose One',
    showValueAsCardNumber = false,
    filledFormData,
    setFormSubmissionPayload,
    validations = [],
    setValidationErrors,
    validationErrors,
    setFocus,
    fieldRank,
    idsToClear,
    entityToEdit,
    dlsSelectKey,
    preFilledWith,
    isPreFilled,
    formContainer,
    setShowPopUp,
    popUpTriggerMappings = {},
    curPageValues,
    setCurPageValues,
    comments,
    setComments,
    dispatchIdsState,
    fieldIdsToClear = [],
    operationsToPerform,
    changePageValues,
    setChangePageValues,
    isChangePageValue,
    fieldDynamicRequired = null,
    dataObject,
  } = props;
  const [expandableTableData, setExpandableTableData] = useState({});
  const options = useDropDownOptions({
    ...props,
    dataObject: {
      formSubmissionPayload: filledFormData,
      memberInfo,
      expandableTableData,
      setExpandableTableData,
    },
  });
  // const [selectedOption, setSelectedOption] = useState('');
  const [showCustomInvalidMsg, setShowCustomInvalidMsg] = useState(false);
  const [status, setStatus] = useState('success');
  const customInvalidMsg = fieldValidation && fieldValidation.customInvalidMsg
    ? fieldValidation.customInvalidMsg
    : 'Please select an item in the list';
  const [value, setValue] = useState('');
  const [validationErrState, dispatchErrState] = useReducer((prevState, payload) => ({ ...prevState, ...payload }), { validationErr: '', isValid: true });
  const optionalLabel = fieldLabel && fieldLabel.optionalLabel ? fieldLabel.optionalLabel : ' (Optional)';

  const updatePayloadWithValue = (val) => {
    if (onElementChange && onElementChange.length > 0) {
      onElementChange.forEach((changeEvent) => {
        changeEvent.functionsToCall.forEach((fn) => {
          switch (fn.name) {
            case 'setFormSubmissionPayload':
              if (val) {
                filledFormData[fieldId] = val;
                setFormSubmissionPayload({ ...filledFormData, elemId: fieldId });
              } else {
                delete filledFormData[fieldId];
                setFormSubmissionPayload({ ...filledFormData, elemId: fieldId });
              }
              break;
            default: return true;
          }
          return true;
        });
        return true;
      });
    }
  };

  const performCustomValidations = (params) => {
    const { inputVal, validationsToPerform } = params;
    const invalidMsg = validateDlsInput(inputVal, validationsToPerform, { ...dataObject, isFieldRequired: fieldValidation.required });
    if (invalidMsg) {
      dispatchErrState({ validationErr: `${invalidMsg}`, isValid: false });
    } else {
      dispatchErrState({ validationErr: '', isValid: true });
    }
  };

  useEffect(() => {
    // This will clear the mandatory error message for this input
    if (fieldDynamicRequired && fieldValidation && !fieldValidation.required) {
      const mandatoryValidation = validations.find((val) => val.type === 'mandatoryField');
      if (mandatoryValidation) {
        performCustomValidations({ inputVal: value, validationsToPerform: validations });
      }
    }
  }, [fieldValidation.required]);
  /**
   * Handle dropdown selection
   */
  const handleSelect = (e, val = null) => {
    // If any input needs to cleanup
    if (fieldIdsToClear && fieldIdsToClear.length > 0) {
      const clearIds = {};
      fieldIdsToClear.forEach((id, i) => {
        clearIds[id] = i + 1;
      });
      dispatchIdsState({ toggleState: !idsToClear.toggleState, ids: clearIds });
      /*
      setTimeout(() => {
        dispatchIdsState({ ids: {} });
      }, 500); */ }
    if (comments && comments[fieldId]) {
      delete comments[fieldId];
      setComments({ ...comments });
    }
    const selectedVal = e ? e.target.value : val;
    if (validations.length > 0) {
      performCustomValidations({ inputVal: selectedVal, validationsToPerform: validations });
    }
    if (operationsToPerform?.onChange?.length > 0) {
      performOperations({
        value: selectedVal,
        operations: operationsToPerform.onChange,
        dataObject: {
          memberInfo,
          formSubmissionPayload: filledFormData,
          curPageValues,
          expandableTableData,
          setExpandableTableData,
          changePageValues,
          setChangePageValues,
          selectedVal,
          e,
        },
        functionObject: { setFormSubmissionPayload },
        formContainer,
        setFormSubmissionPayload,
        fieldId,
        e,
      });
    }
    if (e && onElementChange?.length > 0) {
      handleOnChangeEvents(onElementChange, e);
    }
    if (popUpTriggerMappings && popUpTriggerMappings[selectedVal]) {
      setShowPopUp(popUpTriggerMappings[selectedVal]);
    }
    setCurPageValues({ ...curPageValues, [fieldId]: selectedVal });
    setValue(selectedVal);

    if (isChangePageValue) {
      changePageValues[fieldId] = selectedVal;
      setChangePageValues({ ...changePageValues });
    }
  };

  useEffect(() => {
    if (isChangePageValue && fieldId in changePageValues) {
      setValue(getVal(changePageValues, fieldId));
    }
    if (!validationErrState.isValid) {
      performCustomValidations({ inputVal: getVal(changePageValues, fieldId), validationsToPerform: validations });
    }
  }, [changePageValues, isChangePageValue]);
  /**
   * Clear the values from previous select components
  */

  useEffect(() => {
    if (filledFormData && filledFormData[fieldId]) {
      setValue(filledFormData[fieldId]);
      curPageValues[fieldId] = filledFormData[fieldId];
      setCurPageValues({ ...curPageValues });
      if (isChangePageValue) {
        changePageValues[fieldId] = filledFormData[fieldId];
        setChangePageValues({ ...changePageValues });
      }
    }
  }, [fieldId]);

  // need to take out code of fieldId change from here
  useEffect(() => {
    if (isPreFilled && preFilledWith === 'filledFormData' && !fetchUrl) {
      if (filledFormData) {
        setValue(getVal(filledFormData, dlsSelectKey));
      }
    } else if (isChangePageValue && fieldId in changePageValues) {
      setValue(getVal(changePageValues, fieldId));
    }
  }, [filledFormData, fieldId]);

  useEffect(() => {
    // validationErr also can change multiple times, so need one isValid
    if (validationErrState.isValid && validationErrors[fieldRank]) {
      delete validationErrors[fieldRank];
      setValidationErrors(validationErrors);
    } else if (!validationErrState.isValid) {
      setValidationErrors({ ...validationErrors, ...{ [fieldRank]: `${fieldId}` } });
    }
  }, [validationErrState.isValid]);

  useEffect(() => {
    if (entityToEdit && entityToEdit[fieldId]) {
      handleSelect(null, entityToEdit[fieldId]);
      updatePayloadWithValue(entityToEdit[fieldId]);
      if (isChangePageValue) {
        changePageValues[fieldId] = entityToEdit[fieldId];
        setChangePageValues({ ...changePageValues });
      }
    }
  }, [entityToEdit]);

  useEffect(() => {
    if (getVal(idsToClear.ids, fieldId)) {
      updatePayloadWithValue(null);
      setValue('');
      changePageValues[fieldId] = '';
      setChangePageValues({ ...changePageValues });
      delete curPageValues[fieldId];
      setCurPageValues({ ...curPageValues });
      delete filledFormData[fieldId];
      setFormSubmissionPayload({ ...filledFormData });
      // should we delete this fieldID from filledFormData as well?
      delete idsToClear.ids[fieldId];
      dispatchIdsState({ toggleState: idsToClear.toggleState, ids: idsToClear });
    }
  }, [idsToClear.toggleState]);

  const invalidHandler = (e) => {
    if (validations.length > 0) {
      e.preventDefault();
      handleSelect(e);
      setFocus({ ...validationErrors, ...{ [fieldRank]: `${fieldId}` } });
    } else if (fieldValidation && fieldValidation.hideDefaultValidationMsg) {
      e.preventDefault();
      document.querySelector(`#${fieldId}`).focus();
      setShowCustomInvalidMsg(true);
      setStatus('error');
    } else {
      e.target.setCustomValidity(`${customInvalidMsg}`);
    }
  };
  const onInputHandler = (e) => {
    e.target.setCustomValidity('');
    setShowCustomInvalidMsg(false);
    setStatus('success');
  };

  return (
    <div className={cssProperties.style} data-toggle="select">
      {
        fieldLabel && fieldLabel.label && (
          <label htmlFor={fieldId} className={fieldLabel.cssProperties.style}>
            {parseHtml(fieldLabel.label)}
            <span> </span>
            {!fieldValidation.required && <span>{optionalLabel}</span>}
          </label>
        )
      }
      {fieldValidation && fieldValidation.isToolTip
        && (
          <>
            <span>{' '}</span>
            <Tooltip id="ToolTip" triggerElement={<TooltipButton icon={<IconInfo size="sm" title="info" />} />}>{fieldValidation.toolTipInfo}</Tooltip>
          </>
        )}
      {fieldLabel && fieldLabel.subLabel && (
        <div>
          <label
            htmlFor={fieldId}
            className={fieldLabel.cssProperties.subLabelStyle}
          >
            {parseHtml(fieldLabel.subLabel)}
          </label>
        </div>
      )}
      <Select
        className="select fluid form-control"
        status={status}
        name={fieldId}
        id={fieldId}
        aria-label="navigate to"
        value={value}
        onChange={handleSelect}
        // onClick={styleSelectedOption}
        required={fieldValidation.required}
        disabled={fieldValidation.disabled}
        title=""
        onInvalid={invalidHandler}
        onInput={onInputHandler}
      >
        {
          !selectKey && !selectShowKey && Array.isArray(options)
            ? options.map((option) => (
              <SelectOption id={option.id} key={option.value} value={option.value}>
                {option.label}
              </SelectOption>
            ))
            : (
              <>
                <SelectOption value="">
                  {fieldDefaultOptionLabel}
                </SelectOption>
                {
                  !showProductInfo && options && options.length > 0
                    ? options.map((optionObj) => (
                      <SelectOption
                        key={optionObj[selectKey].accountKey ? optionObj[selectKey].accountKey : optionObj.accountToken}
                        value={optionObj[selectKey].accountKey ? optionObj[selectKey].accountKey : optionObj.accountToken}
                      >
                        {optionObj[selectKey][selectShowKey]}
                      </SelectOption>
                    ))
                    /* eslint-disable unicorn/no-nested-ternary -- required T */
                    : !showValueAsCardNumber && options && options.length > 0
                      ? options.map((optionObj) => (
                        <SelectOption
                          key={optionObj[selectKey].accountKey ? optionObj[selectKey].accountKey : optionObj.accountToken}
                          value={optionObj[selectKey].accountKey ? optionObj[selectKey].accountKey : optionObj.accountToken}
                        >
                          {getVal(optionObj, 'product.digitalInfo.productDesc') ? optionObj.product.digitalInfo.productDesc : ''} (-
                          {optionObj[selectKey][selectShowKey].split('-')[2]})
                        </SelectOption>
                      ))
                      : options
                      && options.length > 0
                      && options.map((optionObj) => (
                        <SelectOption
                          key={optionObj[selectKey][selectShowKey]}
                          value={optionObj[selectKey][selectShowKey]}
                        >
                          {getVal(optionObj, 'product.digitalInfo.productDesc') ? optionObj.product.digitalInfo.productDesc : ''} (-
                          {optionObj[selectKey][selectShowKey].split('-')[2]})
                        </SelectOption>
                      ))
                  /* eslint-enable unicorn/no-nested-ternary -- required T */
                }
              </>
            )
        }
      </Select>
      {fieldValidation.disabled && (
        <input type="hidden" id={fieldId} name={fieldId} value={value} />
      )}
      {showCustomInvalidMsg && (
        <div id="alert-error" className="alert dls-color-warning pad-1-t">
          <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
          <span>{customInvalidMsg}</span>
        </div>
      )}
      {
        validationErrState.validationErr
        && (
          <div id="alert-error" className="alert dls-color-warning pad-1-t col-md-12">
            <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
            <span>{parseHtml(validationErrState.validationErr)}</span>
          </div>
        )
      }
      {
        comments && comments[fieldId]
        && (
          <div id="alert-error" className="alert dls-color-warning pad-1-t">
            <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
            <span>{comments[fieldId].comment}</span>
          </div>
        )
      }
    </div>
  );
};
/* eslint-enable max-len -- need */
DlsSelect.propTypes = {
  fetchUrl: PropTypes.string,
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  selectKey: PropTypes.string,
  selectShowKey: PropTypes.string,
  onElementChange: PropTypes.arrayOf(PropTypes.shape),
  handleOnChangeEvents: PropTypes.func,
  showProductInfo: PropTypes.bool,
  fieldDefaultOptionLabel: PropTypes.string,
  showValueAsCardNumber: PropTypes.bool,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  setValidationErrors: PropTypes.func,
  validationErrors: PropTypes.objectOf(PropTypes.shape),
  validations: PropTypes.arrayOf(PropTypes.shape),
  setFocus: PropTypes.func,
  fieldRank: PropTypes.number,
  setFormSubmissionPayload: PropTypes.func,
  idsToClear: PropTypes.objectOf(PropTypes.shape),
  entityToEdit: PropTypes.objectOf(PropTypes.shape),
  dlsSelectKey: PropTypes.string,
  isPreFilled: PropTypes.bool,
  preFilledWith: PropTypes.string,
  setShowPopUp: PropTypes.func,
  popUpTriggerMappings: PropTypes.objectOf(PropTypes.shape),
  curPageValues: PropTypes.objectOf(PropTypes.shape),
  setCurPageValues: PropTypes.func,
  formContainer: PropTypes.objectOf(PropTypes.shape),
  comments: PropTypes.objectOf(PropTypes.shape),
  setComments: PropTypes.func,
  memberInfo: PropTypes.objectOf(PropTypes.shape),
  dispatchIdsState: PropTypes.func,
  fieldIdsToClear: PropTypes.arrayOf(PropTypes.string),
  operationsToPerform: PropTypes.objectOf(PropTypes.shape),
  changePageValues: PropTypes.objectOf(PropTypes.shape),
  setChangePageValues: PropTypes.func,
  isChangePageValue: PropTypes.bool,
  fieldDynamicRequired: PropTypes.objectOf(PropTypes.shape),
  dataObject: PropTypes.objectOf(PropTypes.shape),
};

export default DlsSelect;
